import axios from '../store/sagas/axiosConfig';
import {
  ProxyEndPoint,
  ProxyEndPointTest,
  VGSVault,
  VGSVaultRouteId,
  VGSVaultTest,
  VGSVaultTestRouteId,
} from '../constants';

const isTestEnvironment = () => {
  const defaults = axios.defaults || {};
  return defaults.params && defaults.params.isTest;
};

const selectByEnvironment = (testValue, prodValue) => (
  isTestEnvironment() ? testValue : prodValue
);

const getVGSProxyEndpoint = () => {
  if (axios.defaults && axios.defaults.baseURL
    && (axios.defaults.baseURL.indexOf('localhost:5000') > -1
     || axios.defaults.baseURL.indexOf('.test.travelwits.com') > -1)) return '';

  return selectByEnvironment(ProxyEndPointTest, ProxyEndPoint);
};

const getVGSVault = () => selectByEnvironment(VGSVaultTest, VGSVault);

const getVGSVaultRouteId = () => selectByEnvironment(VGSVaultTestRouteId, VGSVaultRouteId);

export { getVGSVault, getVGSVaultRouteId, isTestEnvironment };
export default getVGSProxyEndpoint;
